import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActions = ({
  selectedCount,
  onBulkDelete,
  onBulkExport,
  onBulkStatusChange,
  onClearSelection,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center space-x-3 space-x-reverse">
          <Icon name="CheckSquare" size={20} className="text-primary" />
          <span className="font-medium text-foreground">
            {selectedCount?.toLocaleString('fa-IR')} درخواست انتخاب شده
          </span>
        </div>

        <div className="flex items-center space-x-2 space-x-reverse">
          <Button
            variant="outline"
            size="sm"
            onClick={onBulkExport}
            className="flex items-center space-x-1 space-x-reverse">
            <Icon name="Download" size={16} />
            <span>خروجی اکسل</span>
          </Button>

          <div className="relative group">
            <Button
              variant="outline"
              size="sm"
              className="flex items-center space-x-1 space-x-reverse">
              <Icon name="Edit" size={16} />
              <span>تغییر وضعیت</span>
              <Icon name="ChevronDown" size={14} />
            </Button>

            {/* Status Change Dropdown */}
            <div className="absolute top-full left-0 mt-1 w-48 bg-popover border border-border rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-10">
              <div className="p-1">
                <button
                  onClick={() => onBulkStatusChange('در حال بررسی')}
                  className="w-full text-right px-3 py-2 text-sm hover:bg-muted rounded-sm transition-colors">
                  در حال بررسی
                </button>
                <button
                  onClick={() => onBulkStatusChange('تکمیل شده')}
                  className="w-full text-right px-3 py-2 text-sm hover:bg-muted rounded-sm transition-colors">
                  تکمیل شده
                </button>
                <button
                  onClick={() => onBulkStatusChange('نیاز به بازنگری')}
                  className="w-full text-right px-3 py-2 text-sm hover:bg-muted rounded-sm transition-colors">
                  نیاز به بازنگری
                </button>
              </div>
            </div>
          </div>

          <Button
            variant="destructive"
            size="sm"
            onClick={onBulkDelete}
            className="flex items-center space-x-1 space-x-reverse">
            <Icon name="Trash2" size={16} />
            <span>حذف</span>
          </Button>

          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="flex items-center space-x-1 space-x-reverse">
            <Icon name="X" size={16} />
            <span>لغو انتخاب</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;
